import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { Visibility, Close, Delete } from '@mui/icons-material';
import { NoteView } from '../../../../../services/CaseManagementService';
import { useViewNote } from './hooks';
import {
  NoteMetadataSection,
  NoteContentSection,
  NoteIdSection
} from './components';

interface ViewNoteDialogProps {
  open: boolean;
  note: NoteView | null;
  onClose: () => void;
}

const ViewNoteDialog: React.FC<ViewNoteDialogProps> = ({ open, note, onClose }) => {
  const { canDelete, handleDelete, formatDate } = useViewNote(note, onClose);

  if (!note) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogTitle
        sx={{
          pb: 2,
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Visibility sx={{ color: '#3b82f6' }} />
        View Note Details
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <NoteMetadataSection
          addedBy={note.addedBy}
          addDate={note.addDate}
          canDelete={canDelete}
          formatDate={formatDate}
        />

        <NoteContentSection text={note.text} />

        <NoteIdSection noteId={note.noteId} />
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          borderTop: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc',
          justifyContent: 'space-between'
        }}
      >
        {canDelete && (
          <Button
            onClick={handleDelete}
            variant="outlined"
            startIcon={<Delete />}
            color="error"
            sx={{
              borderColor: '#dc2626',
              color: '#dc2626',
              '&:hover': {
                borderColor: '#b91c1c',
                backgroundColor: '#fef2f2'
              }
            }}
          >
            Delete Note
          </Button>
        )}

        <Button
          onClick={onClose}
          variant="contained"
          startIcon={<Close />}
          sx={{
            backgroundColor: '#162346',
            marginLeft: 'auto',
            '&:hover': {
              backgroundColor: '#1a2a52'
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewNoteDialog;
